import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["container", "hiddenSelectField", "placeholder"];

	connect() {
		document.addEventListener("click", (e) => {
			this.closeSelectFieldsOnDocumentClick(e);
		});
	}

	toggle(e) {
		e.preventDefault();

		if (this.containerTarget.hasAttribute("data-group-toggle")) {
			this.containerTarget.removeAttribute("data-group-toggle");
		} else {
			this.containerTarget.setAttribute("data-group-toggle", true);
		}
	}

	closeSelectFieldsOnDocumentClick(e) {
		if (
			!this.containerTarget.contains(e.target) &&
			!e.target.getAttribute("data-field")
		) {
			console.log(e.target);
			this.containerTarget.removeAttribute("data-group-toggle");
		}
	}

	selectOption(e) {
		e.preventDefault();

		if (e.currentTarget.getAttribute("data-group-toggle-secondary") == "true") {
			const buttonSelector =
				'button[data-value="' +
				e.currentTarget.getAttribute("data-value") +
				'"][data-field="' +
				this.hiddenSelectFieldTarget.getAttribute("name") +
				'"]';

			const label = document.querySelector(
				'[data-emerce-tv-search-target="channelLabelsContainer"] ' +
					buttonSelector
			);

			label.click();
		} else {
			e.currentTarget.setAttribute("data-group-toggle-secondary", true);

			const options = Array.from(
				this.hiddenSelectFieldTarget.querySelectorAll("option")
			);

			options.find(
				(c) => c.value == e.currentTarget.getAttribute("data-value")
			).selected = true;
		}

		this.setPlaceholder();
		this.hiddenSelectFieldTarget.dispatchEvent(new Event("change"));
	}

	setPlaceholder() {
		const buttons = document.querySelectorAll(
			'button.group-toggleable-secondary[data-group-toggle-secondary]'
		);

		const parentContainer = this.placeholderTarget.parentNode.parentNode;
		if(buttons.length == 0) {
			this.placeholderTarget.innerHTML = 'Channel';
			if(parentContainer.classList.contains('filter-active')) {
				parentContainer.classList.remove('filter-active')
			}
		} else {
			this.placeholderTarget.innerHTML = 'Channel (' + buttons.length + ')';
			if(!parentContainer.classList.contains('filter-active')) {
				parentContainer.classList.add('filter-active')
			}
		}
	}
}
